import { FaStar, FaStarHalf } from "react-icons/fa";

interface ReviewStarsProps {
  rating: number;
  size?: number;
  style?: object;
  color?: string;
}
export default function ReviewStars({
  rating,
  size,
  style,
  color,
}: ReviewStarsProps) {
  const fullStar = new Array(Math.floor(rating)).fill(1);
  const halfStar = rating % 1 ? [1] : [];

  return (
    <div style={style}>
      {fullStar.map((s, index) => {
        return (
          <FaStar
            size={size}
            color={color ? color : "#EC4F4D"}
            key={index}
            style={{ marginRight: 4 }}
          />
        );
      })}
      {halfStar.map((s, index) => {
        return (
          <FaStarHalf
            size={size}
            color={color ? color : "#EC4F4D"}
            key={index}
          />
        );
      })}
    </div>
  );
}
